import type { AppThunkDispatch, RootState } from '../..';
import { NodeBase } from '../../../entities/Node';
import { createItemsCategoryRecommendationsNodes } from '../../../utils/item/createItemsCategoryRecomendationsNodes';
import { PANE_SOURCETREE, PANE_TARGETTREE } from '../../constants/panes';
import { updateData } from '../../slices/tree';
import { getItemsCategoryRecommendations } from '../api/items';

export const fetchItemsCategoryRecommendations =
  (tree: string, catalogId: string) =>
  async (dispatch: AppThunkDispatch, getState: () => RootState) => {
    const items = await dispatch(getItemsCategoryRecommendations()).unwrap();
    const state = getState();
    const panes = state.pane;

    if (!panes[PANE_SOURCETREE] || !panes[PANE_TARGETTREE]) {
      return null;
    }

    const itemCategoryRecommendationsNodes = createItemsCategoryRecommendationsNodes(
      {
        catalogId,
        items,
      },
    );

    return dispatch(
      updateData(tree, itemCategoryRecommendationsNodes as unknown as NodeBase[], {
        meta: {
          totalNumberOfElements: items.length,
        },
      }),
    );
  };
